<template>
  <div id="app">
    <div class="main__content">
      <header>
        <div class="header__filter" />
        <div class="container header__container">
          <div class="container__inner">
            <div class="floating__items">
              <div class="logo"><img
                src="./assets/img/solar-logo.png"
                alt="Check solar savings"
              ></div>
              <div class="secure">
                <img
                  src="./assets/img/secure.svg"
                  alt="lock"
                >
                <span class="desktop--show">Safe, secure & 100% confidential</span>
                <span class="mobile--show">Secure</span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main class="container">
        <ProgressBar
          v-if="currentStep > 0 && currentStep < 6"
          :current-step="currentStep"
          :max-steps="stepsList.length - 2"
        />
        <Form
          v-if="currentStep < 6"
          :step="stepsList[currentStep]"
          @stepValid="changeStep"
          @skipToNext="skipStep"
          @invalidZip="showInvalid"
        />
        <Loader v-if="currentStep === 6" />
        <invalid-zip
          v-if="currentStep === 7"
          :camp="campId"
        />
      </main>
    </div>
    <Footer />
  </div>
</template>

<script>
import ProgressBar from './components/common/ProgressBar'
import Form from './components/Form'
import Loader from './components/form-elements/Loader'
import InvalidZip from './components/form-elements/InvalidZip'
import Footer from './components/common/Footer'

import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    ProgressBar,
    Form,
    Loader,
    InvalidZip,
    Footer
  },
  data () {
    return {
      currentStep: undefined,
      campId: '',
      clickId: '',
      formData: {},
      stepsList: ['property-zip', 'electric-bill', 'home-owner', 'shade', 'personal-info', 'personal-contacts', 'loader', 'not-available'],
      stepsHistory: [],
      formSubmitted: false
    }
  },
  watch: {
    '$route' (newValue, oldValue) {
      let toStep = newValue.path.replace(process.env.VUE_APP_SUBDIR + '/', '')
      let fromStep = oldValue.path.replace(process.env.VUE_APP_SUBDIR + '/', '')

      let forward = this.isForward(toStep, fromStep)
      if (forward === false && fromStep !== '' && this.currentStep !== 6) {
        if (this.isVisited(toStep) === true) {
          let previousStepName = this.stepsHistory[this.stepsHistory.indexOf(fromStep) - 1]
          this.currentStep = this.stepsList.indexOf(previousStepName)
        }
      } else {
        window.scrollTo(0, 0)
      }
      if (this.currentStep < 0 && this.currentStep !== undefined) {
        this.currentStep = 0
      }
      if (process.env.NODE_ENV === 'production') {
        this.$gtm.push({
          event: 'VirtualPageview',
          virtualPageURL: this.stepsList[this.currentStep],
          virtualPageTitle: this.stepsList[this.currentStep] })
      }
    }
  },
  created () {
    const queryParams = this.$route.query
    this.clickId = queryParams['clickid']
    this.campId = queryParams['campid']
    this.checkQueryParams(queryParams)
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') window.onbeforeunload = this.leaving
  },
  methods: {
    changeStep (data) {
      let direction = 'next'
      for (const [key, value] of Object.entries(data)) {
        this.formData[key] = value
      }
      // localStorage.formInfo = JSON.stringify(data)
      // localStorage.visitedSites = JSON.stringify(this.stepsHistory)
      if (direction === 'next') {
        if (this.stepsList.length - 3 === this.currentStep && this.formSubmitted === false) {
          data.campId = this.campId
          data.clickId = this.clickId
          data.zipCode = this.formData.zipCode
          data.state = this.formData.state
          data.city = this.formData.city
          data.payout = this.formData.payout
          data.a = 'cleanexperts'
          let clientID = 2
          this.currentStep++
          axios.post('//' + process.env.VUE_APP_LINK + '/api/form/submit', { clientId: clientID, formData: qs.stringify(data, { encode: true }) }).then((response) => {
            if (data.firstName === 'test') console.log(response.data)
            window.location.href =
                `thank-you.html?firstName=${this.formData.firstName}`
          })
          this.formSubmitted = true
        } else {
          this.currentStep++
          this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
        }
        this.insertValue(this.currentStep, this.stepsList[this.currentStep])
      } else {
        this.currentStep--
      }
    },
    skipStep (data) {
      this.formData = data
      this.stepsHistory.splice(this.currentStep + 1, 1)
      this.currentStep += 2
      this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
      this.insertValue(this.currentStep, this.stepsList[this.currentStep])
      // localStorage.formInfo = JSON.stringify(data)
    },
    isForward (to, from) {
      return (this.stepsList.indexOf(to) >= this.stepsList.indexOf(from))
    },
    isVisited (to) {
      return (this.stepsHistory.indexOf(to) > -1)
    },
    insertValue (index, value) {
      if (!this.stepsHistory.includes(this.stepsList[this.currentStep])) this.stepsHistory.splice(index, 0, value)
    },
    checkData (index, value = '') {
      return (!index) ? value : index
    },
    leaving (e) {
      if (this.currentStep < 5) {
        e.returnValue = false
      }
    },
    showInvalid () {
      this.insertValue(this.currentStep + 1, this.stepsList[this.currentStep])
      this.currentStep = 7
      this.$router.push({ path: 'not-available', name: 'not-available', query: this.$route.query })
    },
    checkQueryParams (params) {
      if (params['zipCode']) {
        axios.post('//' + process.env.VUE_APP_LINK + '/api/check/zip', { zipCode: params['zipCode'] })
          .then((response) => {
            if (response.data !== false) {
              console.log(response.data)
              this.formData.payout = response.data.payout
              this.formData.zipCode = params['zipCode']
              this.formData.state = params['state']
              this.formData.city = params['city']
            } else {
              this.formData.payout = 0
            }
            this.currentStep = 1
            this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.currentStep = 0
        this.$router.push({ path: this.stepsList[0], name: this.stepsList[0], query: this.$route.query })
        this.stepsHistory.push(this.stepsList[0])
      }
    }
  }
}
</script>
